import React from 'react';
import './modalcontact.scss';
import { Modal } from 'antd';
import Contact from './Contact';

export default (props)=>{

   
    return(
    <Modal
    title=""
    centered
    visible={props.visible}

    width={"100%"}
    closable={false}
    footer={null}
    bodyStyle={{
    padding:0,
    }}
    maskStyle={{
        background:" -webkit-gradient(linear, center top, center bottom, from(#323758), to(#202430))",
    }}
    >
    <Contact /> <button className="modalback" onClick={props.onClose}>返回</button>
    </Modal>
)
}